import styled from "styled-components";
import { Box as MuiBox, Typography as MuiTypography } from "@mui/material";

export const Wrap = styled(MuiBox)`
  &.MuiBox-root {
    width: 100%;
    max-width: calc(2420px - 256px - 96px);
  }
  outline: none;
`;

export const Container = styled(MuiBox)`
  &.MuiBox-root {
    width: 100%;
    height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Box = styled(MuiBox)`
  &.MuiBox-root {
    height: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
  }
  // & .MuiButtonBase-root {
  //   color: #79747e;
  // }
  & .MuiFormControl-root.MuiTextField-root {
    width: 200px;
    font-size: 14px;
  }
`;

export const SecondContainer = styled(MuiBox)`
  &.MuiBox-root {
    padding-top: 10px;
    /* 58% 로 두면 요약 줄에 477px 밖에 안 돌아가 오른쪽 659px 이 그대로 버려진다.
       (예전엔 ThirdBox 에 width:940px 을 박아 컨테이너 밖으로 넘겨 쓰고 있었다)
       Templates / AI Review 요약 줄과 같이 100% 를 쓰고, Search 는 오른쪽 끝에 맞춘다. */
    width: 100%;
    /* height 고정이면 요약 줄이 wrap 됐을 때 늘어난 내용이 밖으로 넘친다.
       min-height 로 두어 줄이 늘면 컨테이너도 같이 늘어나게 한다. */
    min-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
  }
`;

export const SecondBox = styled(MuiBox)`
  &.MuiBox-root {
    /* SecondContainer 와 같은 이유로 고정 height 를 쓰지 않는다. */
    min-height: 60px;
    display: flex;
    gap: 2px;
    margin-left: 10px;
  }
  // & .MuiButtonBase-root {
  //   color: #79747e;
  // }
  & .MuiFormControl-root.MuiTextField-root {
    width: 200px;
    font-size: 14px;
  }
`;

export const ThirdBox = styled(MuiBox)`
  &.MuiBox-root {
    /* 고정 height 면 요약 줄이 wrap 됐을 때 넘친 줄이 아래 줄과 겹친다. */
    min-height: 20px;
    display: flex;
    margin-left: 10px;
    gap: 2px;
  }
  // & .MuiButtonBase-root {
  //   color: #79747e;
  // }
  & .MuiFormControl-root.MuiTextField-root {
    width: 200px;
    font-size: 14px;
  }
`;

export const Typography = styled(MuiTypography)`
  &.MuiTypography-root {
    /* flex-direction / justify-content 는 두지 않는다.
       이 컴포넌트는 보통 display:block 인 <p> 라 예전엔 무해했지만,
       요약 줄의 값 자리처럼 display:inline-flex 를 주는 순간 살아나
       내용(별 아이콘 등)을 세로로 쌓아버린다.
       &.MuiTypography-root 가 sx 보다 특이도가 높아 호출부에서 못 덮는다. */
    font-size: 12px;
    text-overflow: ellipsis;
  }
`;
